import { default as BackgroundComponent, Background, BackgroundArray } from './Background';

export { Background, BackgroundArray };

export default BackgroundComponent;
